import Swiper from 'swiper/bundle';

(function ($) {
    let swiper = new Swiper(".history-date .swiper-container", {
        spaceBetween: 20,
        slidesPerView: 1,
        loop: false,
        centeredSlides: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
        },
        breakpoints: {
            300: {
                spaceBetween: 24,
            },
            768: {
                spaceBetween: 16,
            },
            1024: {
                spaceBetween: 92,
            },
            1440: {
                spaceBetween: 20,
            },
        }
    });

})(jQuery);
